export class GeoEnvironment {
  public static getName = () => 'benzinga-geo';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/api/'),
  });
}
